import { useCallback, useState } from 'react';
import { SettingsApi } from '@/features/settings/api';
import { queryClient } from '@/app/QueryClientProvider';
import { usePopups } from '@/hooks';

export const useUpdateSettings = () => {
  const { showErrorToast, showSuccessToast } = usePopups();

  const [isUpdating, setIsUpdating] = useState(false);

  const handleUpdate = useCallback(async ({ id, text, type }) => {
    try {
      setIsUpdating(true);
      const res = await SettingsApi.updateSettings({ id, text, type });
      await queryClient.refetchQueries({ queryKey: [SettingsApi.getSettings] });
      showSuccessToast('Saved');
      return res;
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsUpdating(false);
    }
  }, []);

  return {
    handleUpdate,
    isUpdating
  };
};
